import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'arts/config/numeral';
import { FORMAT } from '../checkout_summary/checkout_summary';
import ArtItem from './art_item';
import RemoveCartItem from './remove_cart_item';
import * as Classes from './styles.module.scss';

const WallGroup = ({
  wallId,
  wallName,
  wallPreviewUrl,
  pieceCount,
  items,
  discountItem,
  editable,
  removeCartItem,
  removeCartWall,
  locale
}) => {
  if (locale) { numeral.locale(locale); }

  const discount = discountItem && discountItem.discountPercent ? (
    <div className={ Classes.wallDiscount }>
      <div className={ Classes.wallBadge }>
        { `${ discountItem.discountPercent }% Wall Discount` }
      </div>
      <div className={ Classes.wallDiscountNote }>
        For Purchasing an Entire Wall
      </div>
    </div>
  ) : null;

  const price = discountItem ? (
    <div className={ Classes.wallPrice }>
      <span className={ Classes.old }>
        { numeral(discountItem.previousPrice).format(FORMAT) }
      </span>
      &nbsp;
      <span className={ Classes.new }>
        { numeral(discountItem.newPrice).format(FORMAT) }
      </span>
    </div>
  ) : null;

  return (
    <div className={ Classes.wallGroup }>
      <div className={ Classes.wallHeader }>
        { wallPreviewUrl ? (
          <div className={ Classes.wallPreview }>
            <img src={ wallPreviewUrl } alt={ wallName } />
          </div>
        ) : null }
        <div className={ Classes.info }>
          <h4>
            { wallName }
          </h4>
          <div className={ Classes.by }>
            { `Gallery Wall (${ pieceCount } pieces)` }
          </div>
          { discount }
        </div>
        { editable && removeCartWall ? (
          <RemoveCartItem
            label="Remove Wall"
            onRemove={ () => removeCartWall(wallId) }
          />
        ) : null }
      </div>
      { price }
      {
        items.map((item, index) => (
          <ArtItem
            { ...item }
            key={ item.id }
            nOfM={ `${ index + 1 } of ${ pieceCount }` }
            editable={ editable }
            removeCartItem={ removeCartItem }
            locale={ locale }
          />
        ))
      }
    </div>
  );
};

WallGroup.propTypes = {
  wallId: PropTypes.number,
  wallName: PropTypes.string,
  wallPreviewUrl: PropTypes.string,
  pieceCount: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  discountItem: PropTypes.shape({
    discountPercent: PropTypes.number,
    previousPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    newPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  editable: PropTypes.bool,
  removeCartItem: PropTypes.func,
  removeCartWall: PropTypes.func,
  locale: PropTypes.string
};

export default WallGroup;
